<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';

import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";
/**
 * Basic-table component
 */
export default {
  components: {ErrorMessage, Layout, PageHeader, flashMessage ,ModelSelect},
  data() {
    return {
      title: "Role Assign B2C User",
      items: [
        {
          text: "B2c User",
          href: "/",
        },
        {
          text: "Role Assign B2C",
          active: true,
        },
      ],
      roles: [],
      admins: [],
      errors: null,
      submitform: false,
        errorshow:false,
        visible:false,
      submitted: false,
        message:"",
      form: {
        user_id: undefined,
        role_id: undefined,
      },
    };
  },
  validations: {
    form: {
      user_id: {
        required,
      },
      role_id: {
        required,
      },
    },
  },
  mounted() {
    this.getRoleList();
    this.getUserList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      async getUserList() {
          this.submitted = true;
          axios
              .post("/api/user/b2c", {
                  type: "b2c",
                  accessToken: localStorage.getItem("access_tocken"),
              })
              .then((response) => {
                  if (response.data.status) {
                      let temp=response.data.data;
                      let i;
                      let arr=[];
                      for (i=0;i<temp.length;i++){
                          if(temp[i].first_name != null){
                              temp[i].value = temp[i].id;
                              temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                              arr.push(temp[i]);
                          }
                      }
                      this.admins=arr;
                  } else {
                      var str = response.data.message;
                      var jsonParse = JSON.parse(str);
                      this.errorCheck(jsonParse);
                  }
              })
              .catch((error) => {
                  if (error.response != undefined) {
                      this.errors = error.response.data.errors;
                  }
              });
      },
    async getRoleList() {
      try {
        axios
          .get("/api/role_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.roles = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
              console.log(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Role Already Assigned";
            this.errors = obj.message;
        }else if (obj.error) {
            this.errors = obj.message;
        } else if (obj.message == "Token has expired") {
            this.$swal.fire({
                title: 'LogOut!',
                text: 'Token Has Expired',
                icon: 'error',
                toast:'true',
                position: 'top-end',
            });
            this.$router.push({ name: "logout" });
        } else if (
            obj.message !== "Token has expired" &&
            obj.message !== "The given data was invalid."
        ) {
            this.errors = obj.message;
        } else if (obj.message == "The given data was invalid.") {
            this.errors = obj.errors;
        } else {
            this.flashMessage.show({
                time: 5000,
                status: "error",
                title: "Error",
                message: "Problem in data save",
            });
        }
    },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/assign_role", {
          user_id: this.form.user_id,
          role_id: this.form.role_id,
            account_type:'b2c',
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.roleAssignForm.reset();
              if(this.visible){
                  this.visible=false;
              }
              // this.form.user_id=undefined;
              // this.form.role_id=undefined;
              // this.submitted=false;
            this.$swal("Role Assigned", "success");
              this.$router.push({ name: "b2c_user_role_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);

            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
<!--            <div v-if="errors" class="font-bold mb-4 ">-->
<!--              <div v-for="(v, k) in errors" :key="k">-->
<!--                <p v-for="error in v" :key="error" class="text-sm">-->
<!--                  {{ error }}-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->
            <b-form class="needs-validation" ref="roleAssignForm" @submit.prevent="formSubmit">
              <div class="row">
                  <div class="col-md-12">
                      <div class="form-group">
                          <label>Select User</label>
                          <model-select :options="admins"
                                        v-model="form.user_id"
                                        placeholder="Select User">
                          </model-select>
                          <!--                  <select-->
                          <!--                    id="user_id"-->
                          <!--                    name="user_id"-->
                          <!--                    v-model="user_id"-->
                          <!--                    class="form-control"-->
                          <!--                    placeholder="Type Select User">-->
                          <!--                    <option v-for="(admin, index) in admins" :value="admin.id" v-if="admin.account_type == user_type"-->
                          <!--                          v-bind:key="index">{{ admin.first_name+' '+admin.last_name }}-->
                          <!--                  </option>-->
                          <!--                  </select>-->
                      </div>
                  </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="role_id">Select Role</label>
                    <select
                      id="role_id"
                      name="role_id"
                      v-model="form.role_id"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.form.role_id.$error }">
                        <option :value="undefined" disabled style="display:none" selected>Select Role</option>
                      <option v-for="(role, index) in roles" v-if="role.type == 'b2c'" :value="role.id"
                            v-bind:key="index">{{ role.name}}
                    </option>
                    </select>
                    <div
                      v-if="submitted && $v.form.role_id.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.role_id.required">This value is required.</span>
                    </div>
                  </div>
                </div>

              </div>
              <button class="btn btn-primary" type="submit">Assign Role</button>
                <div class="col-md-12 height-30px">

                </div>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.height-30px{
    height: 20px;
}
</style>
